import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { CalendarEvent } from '../ResourceCalendar';
import { isGruppenraumEvent, isStandortEvent } from '../ResourceCalendar/helperClasses/CalendarEvent';
import { CollapseInfo } from './VivaRessourcenCalendars.utils.types';

type UseInitialCollapseInfoProps = {
  collapseFocus?: 'experte' | 'raum';
  pendingEvents?: readonly CalendarEvent[];
};

function createCollapseInfo({ collapseFocus, pendingEvents }: UseInitialCollapseInfoProps): CollapseInfo {
  switch (collapseFocus) {
    case 'raum':
      return {
        seminarraum: false,
        gruppenraum: !pendingEvents?.some(isGruppenraumEvent),
        standort: !pendingEvents?.some(isStandortEvent),
        experte: false,
        haupttrainer: false,
        nebentrainer: false,
        ersatztrainer: false,
      };
    case 'experte':
      return {
        seminarraum: true,
        gruppenraum: true,
        standort: true,
        experte: false,
        haupttrainer: false,
        nebentrainer: false,
        ersatztrainer: false,
      };
    default:
      return {
        seminarraum: false,
        gruppenraum: true,
        standort: true,
        experte: false,
        haupttrainer: false,
        nebentrainer: false,
        ersatztrainer: false,
      };
  }
}

export function useCollapseInfo(
  pendingEvents: readonly CalendarEvent[],
  collapseFocus?: 'experte' | 'raum',
): [CollapseInfo, Dispatch<SetStateAction<CollapseInfo>>] {
  const [collapseInfo, setCollapseInfo] = useState<CollapseInfo>(() => createCollapseInfo({ collapseFocus }));
  const hasInitialized = useRef(false);

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- added during migration to ban-pdk. please solve issue or explain disable-reason here
    if (hasInitialized.current || pendingEvents.length === 0) return;

    hasInitialized.current = true;
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change -- added during migration to ban-pdk. please solve issue or explain disable-reason here
    setCollapseInfo(createCollapseInfo({ collapseFocus, pendingEvents }));
  }, [pendingEvents, collapseFocus]);

  return [collapseInfo, setCollapseInfo];
}
